//SprintCentralThreePF
import React, { useEffect, useState } from 'react'
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFetch from '../../hooks/useFetch';
import adimage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import adimage2 from '../../assets/navlogo.png';
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@fortawesome/free-solid-svg-icons';

const dummyData = [
  {
    sn: 1,
    taskName: "Build Website Landing Page",
    o: 4,
    m: 7,
    p: 16,
    e: 8,
    sd: 2,
    actual: 9,
    diff: 1,
    tDesc: "Develop homepage layout with responsive design",
    pDetails: "Delay possible due to UI redesign",
    oDetails: "If design approved immediately",
    mDetails: "Normal frontend development timeline",
    cost: 5000,
    currency: "₹",
    remarks: "Delivery acceptable",
    userCode: "T5W1001",
    autoTaskCode: "3P-2026-0001",
    taskGroup: "Software",
    taskProject: "Website Revamp",
    taskProgram: "Digital Transformation",
    entityName: "Think5Whys",
    taskDepartment: "Engineering",
    jobID: "DEV-001"
  },
  {
    sn: 2,
    taskName: "Prepare Client Proposal",
    o: 2,
    m: 3,
    p: 6,
    e: 3.5,
    sd: 0.7,
    actual: 4,
    diff: 0.5,
    tDesc: "Consulting proposal for MSME factory",
    pDetails: "Client requirement unclear",
    oDetails: "Existing template available",
    mDetails: "Standard customization",
    cost: 2000,
    currency: "₹",
    remarks: "Client accepted proposal",
    userCode: "T5W1001",
    autoTaskCode: "3P-2026-0002",
    taskGroup: "Consulting",
    taskProject: "MSME Transformation",
    taskProgram: "Industry 4.0",
    entityName: "Think5Whys",
    taskDepartment: "Consulting",
    jobID: "CONS-011"
  },
  // School Students

  {
    sn: 1,
    taskName: "Complete Math Homework",
    o: 30,
    m: 45,
    p: 90,
    e: 50,
    sd: 10,
    actual: 55,
    diff: 5,
    tDesc: "Finish algebra homework worksheet",
    pDetails: "If questions are difficult",
    oDetails: "If concepts already understood",
    mDetails: "Normal homework effort",
    cost: 0,
    currency: "₹",
    remarks: "Completed with minor delay",
    userCode: "STU101",
    autoTaskCode: "3P-2026-0003",
    taskGroup: "Education",
    taskProject: "School Work",
    taskProgram: "Student Productivity",
    entityName: "School",
    taskDepartment: "Student",
    jobID: "STUD-001"
  },

  {
    sn: 2,
    taskName: "Memorize English Poem",
    o: 20,
    m: 40,
    p: 60,
    e: 40,
    sd: 8,
    actual: 35,
    diff: -5,
    tDesc: "Memorize poem for school recitation",
    pDetails: "If difficult vocabulary",
    oDetails: "If short poem",
    mDetails: "Average memorization speed",
    cost: 0,
    currency: "₹",
    remarks: "Completed faster",
    userCode: "STU102",
    autoTaskCode: "3P-2026-0004",
    taskGroup: "Education",
    taskProject: "School Work",
    taskProgram: "Student Productivity",
    entityName: "School",
    taskDepartment: "Student",
    jobID: "STUD-002"
  },

  // Senior Students

  {
    sn: 3,
    taskName: "Prepare Semester Presentation",
    o: 4,
    m: 6,
    p: 10,
    e: 6,
    sd: 1.5,
    actual: 7,
    diff: 1,
    tDesc: "Prepare slides and research topic",
    pDetails: "If research material limited",
    oDetails: "If topic already known",
    mDetails: "Normal preparation",
    cost: 0,
    currency: "₹",
    remarks: "Presentation successful",
    userCode: "COL201",
    autoTaskCode: "3P-2026-0005",
    taskGroup: "Education",
    taskProject: "Semester Project",
    taskProgram: "College Study",
    entityName: "College",
    taskDepartment: "Student",
    jobID: "COL-001"
  },

  {
    sn: 4,
    taskName: "Complete Coding Assignment",
    o: 3,
    m: 5,
    p: 12,
    e: 5.5,
    sd: 2,
    actual: 6,
    diff: 0.5,
    tDesc: "Develop small web application",
    pDetails: "Debugging issues",
    oDetails: "Code template available",
    mDetails: "Normal coding time",
    cost: 0,
    currency: "₹",
    remarks: "Completed successfully",
    userCode: "COL202",
    autoTaskCode: "3P-2026-0006",
    taskGroup: "Education",
    taskProject: "Coding Practice",
    taskProgram: "Computer Science",
    entityName: "College",
    taskDepartment: "Student",
    jobID: "COL-002"
  },

  // Professionals

  {
    sn: 5,
    taskName: "Prepare Monthly Business Report",
    o: 2,
    m: 4,
    p: 7,
    e: 4.2,
    sd: 1,
    actual: 5,
    diff: 0.8,
    tDesc: "Compile data and prepare management report",
    pDetails: "Data collection delays",
    oDetails: "If data ready",
    mDetails: "Standard reporting process",
    cost: 1000,
    currency: "₹",
    remarks: "Delivered to management",
    userCode: "PRO301",
    autoTaskCode: "3P-2026-0007",
    taskGroup: "Business",
    taskProject: "Reporting",
    taskProgram: "Corporate Operations",
    entityName: "Company",
    taskDepartment: "Finance",
    jobID: "REP-001"
  },

  {
    sn: 6,
    taskName: "Fix Software Production Bug",
    o: 1,
    m: 3,
    p: 8,
    e: 3.5,
    sd: 1.8,
    actual: 4,
    diff: 0.5,
    tDesc: "Debug issue affecting payment module",
    pDetails: "Complex dependency issue",
    oDetails: "Simple configuration bug",
    mDetails: "Typical debugging effort",
    cost: 1500,
    currency: "₹",
    remarks: "Bug resolved",
    userCode: "PRO302",
    autoTaskCode: "3P-2026-0008",
    taskGroup: "Software",
    taskProject: "System Maintenance",
    taskProgram: "IT Operations",
    entityName: "Company",
    taskDepartment: "Engineering",
    jobID: "BUG-002"
  },

  // Home / Personal Life

  {
    sn: 7,
    taskName: "Cook Family Dinner",
    o: 30,
    m: 45,
    p: 70,
    e: 48,
    sd: 7,
    actual: 50,
    diff: 2,
    tDesc: "Prepare dinner for family",
    pDetails: "If ingredients missing",
    oDetails: "If preparation ready",
    mDetails: "Normal cooking time",
    cost: 400,
    currency: "₹",
    remarks: "Dinner prepared successfully",
    userCode: "HOME401",
    autoTaskCode: "3P-2026-0009",
    taskGroup: "Home",
    taskProject: "Daily Life",
    taskProgram: "Family Activities",
    entityName: "Home",
    taskDepartment: "Kitchen",
    jobID: "HOME-001"
  },

  {
    sn: 8,
    taskName: "Weekly Grocery Shopping",
    o: 40,
    m: 60,
    p: 90,
    e: 63,
    sd: 10,
    actual: 70,
    diff: 7,
    tDesc: "Purchase household groceries",
    pDetails: "Store crowd or traffic",
    oDetails: "Items quickly available",
    mDetails: "Normal shopping",
    cost: 2500,
    currency: "₹",
    remarks: "Completed weekly shopping",
    userCode: "HOME402",
    autoTaskCode: "3P-2026-0010",
    taskGroup: "Home",
    taskProject: "Household",
    taskProgram: "Daily Activities",
    entityName: "Home",
    taskDepartment: "Family",
    jobID: "HOME-002"
  },

  // MSME

  {
    sn: 9,
    taskName: "Manufacture 100 Product Units",
    o: 4,
    m: 6,
    p: 9,
    e: 6.2,
    sd: 1.3,
    actual: 7,
    diff: 0.8,
    tDesc: "Produce batch of components",
    pDetails: "Machine downtime risk",
    oDetails: "Smooth production run",
    mDetails: "Normal manufacturing process",
    cost: 10000,
    currency: "₹",
    remarks: "Batch completed",
    userCode: "MSME501",
    autoTaskCode: "3P-2026-0011",
    taskGroup: "Manufacturing",
    taskProject: "Production",
    taskProgram: "Factory Operations",
    entityName: "Factory",
    taskDepartment: "Production",
    jobID: "PRD-001"
  },

  {
    sn: 10,
    taskName: "Procure Raw Materials",
    o: 1,
    m: 2,
    p: 4,
    e: 2.2,
    sd: 0.6,
    actual: 3,
    diff: 0.8,
    tDesc: "Purchase raw materials from supplier",
    pDetails: "Supplier delay",
    oDetails: "Stock available",
    mDetails: "Normal procurement cycle",
    cost: 50000,
    currency: "₹",
    remarks: "Materials received",
    userCode: "MSME502",
    autoTaskCode: "3P-2026-0012",
    taskGroup: "Supply Chain",
    taskProject: "Procurement",
    taskProgram: "Factory Operations",
    entityName: "Factory",
    taskDepartment: "Purchase",
    jobID: "PRC-002"
  },

  // Women / Housewives

  {
    sn: 11,
    taskName: "Prepare Festival Sweets",
    o: 2,
    m: 4,
    p: 7,
    e: 4.5,
    sd: 1,
    actual: 5,
    diff: 0.5,
    tDesc: "Prepare traditional sweets for festival",
    pDetails: "If multiple items prepared",
    oDetails: "Single recipe",
    mDetails: "Average cooking effort",
    cost: 1200,
    currency: "₹",
    remarks: "Festival preparation complete",
    userCode: "HOMEW601",
    autoTaskCode: "3P-2026-0013",
    taskGroup: "Home",
    taskProject: "Festival",
    taskProgram: "Family Activities",
    entityName: "Home",
    taskDepartment: "Kitchen",
    jobID: "HWF-001"
  },

  {
    sn: 12,
    taskName: "Organize Family Gathering",
    o: 3,
    m: 5,
    p: 8,
    e: 5.2,
    sd: 1.2,
    actual: 6,
    diff: 0.8,
    tDesc: "Plan and host family dinner",
    pDetails: "Unexpected guests",
    oDetails: "Small gathering",
    mDetails: "Normal preparation",
    cost: 3000,
    currency: "₹",
    remarks: "Event successful",
    userCode: "HOMEW602",
    autoTaskCode: "3P-2026-0014",
    taskGroup: "Home",
    taskProject: "Events",
    taskProgram: "Family Activities",
    entityName: "Home",
    taskDepartment: "Family",
    jobID: "HWF-002"
  },

  // Government

  {
    sn: 13,
    taskName: "Process Citizen Permit Application",
    o: 1,
    m: 3,
    p: 6,
    e: 3.2,
    sd: 1,
    actual: 4,
    diff: 0.8,
    tDesc: "Verify documents and issue permit",
    pDetails: "Missing documents",
    oDetails: "All documents correct",
    mDetails: "Standard verification",
    cost: 0,
    currency: "₹",
    remarks: "Permit issued",
    userCode: "GOV701",
    autoTaskCode: "3P-2026-0015",
    taskGroup: "Public Administration",
    taskProject: "Citizen Services",
    taskProgram: "Government Operations",
    entityName: "Government Office",
    taskDepartment: "Administration",
    jobID: "GOV-001"
  },

  {
    sn: 14,
    taskName: "Digitize Public Records",
    o: 5,
    m: 8,
    p: 14,
    e: 8.5,
    sd: 2,
    actual: 9,
    diff: 0.5,
    tDesc: "Convert physical records into digital format",
    pDetails: "Document scanning delays",
    oDetails: "Good digital tools",
    mDetails: "Standard data entry process",
    cost: 10000,
    currency: "₹",
    remarks: "Records digitized",
    userCode: "GOV702",
    autoTaskCode: "3P-2026-0016",
    taskGroup: "Government",
    taskProject: "Digital Governance",
    taskProgram: "E-Governance",
    entityName: "Government Office",
    taskDepartment: "IT",
    jobID: "GOV-002"
  }

];

const ThreePMyList = () => {
  const authState = useSelector(state => state.authReducer);
  const isLoggedIn = authState?.isLoggedIn || false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showAd, setShowAd] = useState(true);

  const [fetchData, { loading }] = useFetch();
  const [userName, setUserName] = useState(authState.user.name);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
   };

  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [search, setSearch] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const filteredData = (dummyData || []).filter((item) =>
    (item.taskName + item.autoTaskCode)
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const calculateEstimate = (o, m, p) => {
    return (o + 4 * m + p) / 6;
  };

  const calculateSD = (o, p) => {
    return (p - o) / 6;
  };

  const calculateDiff = (actual, estimate) => {
    if (actual === undefined || actual === null) return 0;
    return actual - estimate;
  };

  const calculateAccuracy = (actual, estimate) => {
    if (!actual || actual === 0) return "-";

    const accuracy = 100 - (Math.abs(actual - estimate) / actual) * 100;

    return Math.max(0, accuracy).toFixed(1);
  };

  const calculateBias = (o, m, p) => {

    if (p === o) {
      return { type: "Neutral", icon: "➖" };
    }

    const midpoint = (o + p) / 2;
    const biasIndex = (m - midpoint) / (p - o);

    if (biasIndex > 0.3) return { type: "Pessimistic", icon: "😬" };
    if (biasIndex < -0.3) return { type: "Optimistic", icon: "😅" };

    return { type: "Balanced", icon: "⚖️" };
  };

  return (
    <div className='bg-black text-white [&_p]:text-white'>
      <div className="min-h-screen bg-black p-2 text-sm">
        <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
            <div className='flex flex-col'>
                <h2 className="text-lg lg:text-xl font-semibold text-yellow-200"> 
                    <FontAwesomeIcon icon={faSliders} className="mr-2 text-yellow-500" />
                    Think5Whys PTM 3P
                </h2>
                <h2 className="text-sm lg:text-lg text-gray-200">Practical Thinking Mathematics Three Point Estimation Tool</h2>
                <h2 className="text-xs lg:text-sm text-gray-400 mb-2">A Magical tool for Students, Teachers, Professionals, MSME Onwers, Workers, Children, Family, Government, Business</h2>
            </div>
            <div className="hidden md:flex items-center gap-3">
                {isLoggedIn ? (
                    <>
                    <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
                    <button
                        onClick={handleLogout}
                        className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                        title="Logout"
                    >
                        ⏻
                    </button>
                    </>
                ) : (
                    <>
                        <button
                            onClick={() => navigate("/login")}
                            className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
                        >
                            🔐 
                        </button>
                    </>
                )}
            </div>
            <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
            aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? "×" : "☰"}
            </button>
        </header>

        {isMobileMenuOpen && (
            <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
            {isLoggedIn ? (
                <div className="flex flex-col items-center gap-3">
                <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                    <div className="flex gap-3">
                    <button
                        onClick={handleLogout}
                        className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                    >
                        ⏻
                    </button>
                    </div>
                </div>
            ) : (
                <div className="flex justify-center gap-6">
                <Link to="/login" className="text-teal-300">🔐</Link>
                </div>
            )}
            </div>
        )}
        { showAd && (
          <div
              className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
              onClick={() => navigate("/roomanywhere")}
          >
              <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
              <img
                  src={adimage1} 
                  alt="Ad"
                  className="w-full h-full object-cover"
              />
              </div>
              <div className="flex flex-col text-left">
              <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
              <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
              <p className="text-sm mt-1">Click to see more!</p>
              </div>
          </div>
        )}                
        <div className="bg-black text-white min-h-screen mt-4">
          <h2 className="flex justify-center text-sm lg:text-lg text-yellow-200 mb-4">My 3P List / History</h2>
          <div className="mb-4">
            <input
              type="text"
              placeholder="🔍 Search task name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full text-black p-2 rounded border border-gray-300"
            />
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full text-xs lg:text-sm bg-gray-900">
              <thead className="bg-gray-700 text-yellow-200">
                <tr>
                  <th className="px-2 py-2">SN</th>
                  <th className="px-2 py-2">Task</th>
                  <th className="px-2 py-2">O</th>
                  <th className="px-2 py-2">M</th>
                  <th className="px-2 py-2">P</th>
                  <th className="px-2 py-2">E</th>
                  <th className="px-2 py-2">SD</th>
                  <th className="px-2 py-2">Actual</th>
                  <th className="px-2 py-2">Diff</th>
                  <th className="px-2 py-2">Accuracy %</th>
                  <th className="px-2 py-2">Bias</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => {
                  const estimate = calculateEstimate(item.o, item.m, item.p);
                  const sd = calculateSD(item.o, item.p);
                  const diff = calculateDiff(item.actual, estimate);
                  const accuracy = calculateAccuracy(item.actual, estimate);
                  const bias = calculateBias(item.o, item.m, item.p);
                  return (
                    <React.Fragment key={index}>
                      <tr
                        className="border-b border-gray-700 cursor-pointer hover:bg-gray-800"
                        onClick={() => toggleRow(index)}
                      >

                        <td className="px-2 py-2">{item.sn}</td>
                        <td className="px-2 py-2">{item.taskName}</td>
                        <td className="px-2 py-2">{item.o}</td>
                        <td className="px-2 py-2">{item.m}</td>
                        <td className="px-2 py-2">{item.p}</td>

                        <td className="px-2 py-2">{estimate.toFixed(2)}</td>
                        <td className="px-2 py-2">{sd.toFixed(2)}</td>
                        <td className="px-2 py-2">{item.actual}</td>
                        <td className="px-2 py-2">{diff.toFixed(2)}</td>

                        <td className="px-2 py-2 text-green-300">
                          {accuracy === "-" ? "-" : `${accuracy}%`}
                        </td>

                        <td className="px-2 py-2">
                          {bias.icon} {bias.type}
                        </td>
                      </tr>

                      {selectedRow === index && (
                        <tr>
                          <td colSpan="11" className="bg-gray-800 p-4">

                            <div className="space-y-2 text-xs lg:text-sm">

                              <div><b>Task:</b> {item.taskName}</div>
                              <div><b>Description:</b> {item.tDesc}</div>

                              <div><b>Pessimistic Remarks:</b> {item.pDetails}</div>
                              <div><b>Optimistic Remarks:</b> {item.oDetails}</div>
                              <div><b>Most Likely Remarks:</b> {item.mDetails}</div>

                              <div><b>Estimated Cost:</b> {item.currency} {item.cost}</div>
                              <div><b>Final Remarks:</b> {item.remarks}</div>

                              <div className="mt-2">

                                <div><b>Person Code:</b> {item.userCode}</div>
                                <div><b>3P Task Code:</b> {item.autoTaskCode}</div>
                                <div><b>Task Group:</b> {item.taskGroup}</div>
                                <div><b>Project:</b> {item.taskProject}</div>
                                <div><b>Program:</b> {item.taskProgram}</div>
                                <div><b>Entity:</b> {item.entityName}</div>
                                <div><b>Department:</b> {item.taskDepartment}</div>
                                <div><b>Job ID:</b> {item.jobID}</div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>  
      { showAd && (
          <div
              className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
              onClick={() => window.open("https://www.think5whys.com", "_blank")}
          >
          <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
              <img
              src={adimage2}
              alt="Ad"
              className="w-full h-full object-cover"
              />
          </div>

          <div className="flex flex-col text-left">
              <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
              <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
              <p className="text-sm mt-1">Click to see more!</p>
          </div>
          </div> 
      )}       
    </div>
    <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>    
  </div>
  );
};

export default ThreePMyList;